// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"5e317578","329":"59f264c8","606":"e60c5c85","760":"fd7e0746"}[chunkId] + ".chunk.js";
};